// Navigasi tab bergaya tombol: tab aktif memakai gradien hijau seperti halaman login.
export const pillTabsList =
  'flex w-full flex-wrap items-center justify-start gap-2 h-auto rounded-xl bg-slate-100/70 p-1.5';

export const pillTabsTrigger =
  'flex-1 min-w-[110px] rounded-lg border border-transparent bg-white px-4 py-2 text-sm font-semibold text-slate-600 shadow-sm ' +
  'transition-[background-color,color,box-shadow,transform] duration-200 ' +
  'hover:-translate-y-0.5 hover:text-emerald-700 hover:shadow-md ' +
  'data-[state=active]:bg-[linear-gradient(135deg,#0891b2_0%,#10b981_100%)] data-[state=active]:text-white ' +
  'data-[state=active]:shadow-lg data-[state=active]:shadow-emerald-500/30';
